<script>
import options from './FormAddressField.options'
export default options
</script>

<template>

    <div class="kb-form-address-field-group__input-wrapper FormTextbox" :class="{ 'kb-form-address-field-group--disabled': disabled, 'ValidationRequired': isRequired }">

        <label for="dawa-adresse-vej" class="Form__Element__Caption kb-form-address-field-group__input-label">
            {{ addressLabel  }}
        </label>

        <input class="FormTextbox__Input kb-form-address-field-group__input dawa-adresse-vej"
            :class="{'validation-error': isValidationError}"     
            v-model="addressLine"
            id="dawa-adresse-vej" type="text" 
            aria-describedby="dawa-adresse-vej"
            :aria-invalid="isValidationError"
            :placeholder="addressPlaceholder"
            :required="isRequired ? true : false"
            :onBlur="onchangeCallback ? onchangeCallback : ''"
            autocomplete="new-password"
            :onClick="clearAddress"
            :disabled="disabled"
        />
        <div aria-live="assertive">
            <p class="kb-forms Form__Element__ValidationError" role="alert" v-if="isValidationError">
                {{ errorMessageLabel }}
            </p>
        </div>

    </div>

    <div class="kb-form-address-field-group__input-row FormTextbox" :class="{ 'kb-form-address-field-group--disabled': disabled, 'ValidationRequired': isRequired }">

        <div class="kb-form-address-field-group__input-wrapper kb-form-address-field-group__input-wrapper--shorter">

            <label for="dawa-adresse-postnr" class="Form__Element__Caption kb-form-address-field-group__input-label">
                {{ zipCodeLabel  }}
            </label>

            <input class="FormTextbox__Input kb-form-address-field-group__input kb-form-address-field-group__input--shorter kb-form-address-field-group__pbs-input dawa-adresse-postnr" 
                :class="{'validation-error': isValidationError}"    
                v-model="zipCode"
                :required="isRequired ? true : false"
                id="dawa-adresse-postnr"
                type="text"
                disabled 
                :placeholder="zipCodePlaceholder"  
                />

        </div>

        <div class="kb-form-address-field-group__input-wrapper FormTextbox" :class="{ 'ValidationRequired': isRequired }">

            <label for="dawa-adresse-postnrnavn" class="Form__Element__Caption kb-form-address-field-group__input-label">
                {{ cityLabel  }}
            </label>

            <input class="FormTextbox__Input kb-form-address-field-group__input dawa-adresse-postnrnavn" 
                :class="{'validation-error': isValidationError}"
                v-model="city"
                :required="isRequired ? true : false"
                id="dawa-adresse-postnrnavn" 
                type="text"
                disabled 
                :placeholder="cityPlaceholder"   />

        </div>

    </div>
</template>